import gql from 'graphql-tag';
import { MEASUREMENT_SELECTION } from '@/store/measurementSelection';
import { REPORT_TEMPLATE_IMAGE_REQUEST_FIELDS } from '@/store/reportTemplateImages';
import { ATTACHMENT_FIELDS } from './projectDocumentsFragment';
import { PROJECT_MEASUREMENT_REPORT_PHOTO_FIELDS } from './projectMeasurementReportFields';

const PHOTO_LIST_SELECTION = PROJECT_MEASUREMENT_REPORT_PHOTO_FIELDS.map(
  (field) => `${field} { ${ATTACHMENT_FIELDS} }`
).join('\n');

/**
 * Data of the block project-measurement-report-data ("Aufmaßprotokoll: Erfasste Daten"): the cards
 * (`measurement`), the AC and DC states the block requests, the photo lists of the cards and the
 * reference data of the cards (template images, bricks). Read through
 * `Project.blocks.measurementReportData`, which checks the block's read permission.
 */
export const PROJECT_MEASUREMENT_REPORT_DATA_FIELDS = gql`
  fragment projectMeasurementReportDataFields on ProjectMeasurementReportDataBlock {
    id
    number
    measurement {
      ${MEASUREMENT_SELECTION}
    }
    measurementAcVerificationState
    measurementDcVerificationState
    ${PHOTO_LIST_SELECTION}
    reportTemplateImages {
      ...reportTemplateImageFields
    }
    bricks {
      id
      manufacturer
      type
    }
  }
  ${REPORT_TEMPLATE_IMAGE_REQUEST_FIELDS}
`;
